export enum GameLauncherEvents {
    IncentiveGameRedirect = 'INCENTIVE_GAME_REDIRECT',
    IncentiveGameUpdate = 'INCENTIVE_GAME_UPDATE',
    ReloadSpins = 'RELOAD_SPINS',
    GameClosed = 'GAME_CLOSED',
    GameLauncherClose = 'GAME_LAUNCHER_CLOSE'
}

export enum PageType {
    HUB = 'hub',
    OFFER = 'offer'
}

export const REFERRER_PLACEHOLDER = 'referrer-placeholder';
